import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/consent/:id",
    name: "Consent",
    component: () => import("../views/Consent.vue"),
  },
  {
    path:"/renew-consent-success",
    name:"200",
    component:() => import("../views/RenewConsentSuccess.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
